module.exports = __webpack_public_path__ + "7dc5fc0086dce7b73e9215ef4760d3df.svg";